module.exports = __webpack_public_path__ + "img/home5.53beb53c.png";